<template>
  <v-dialog v-model="localDisplay" width="700">
    <v-card class="rounded-lg" flat>
      <v-card-title class="justify-center text-color mt-2">
        <span v-if="value.type === 'create'">
          {{ $t('signup.stakeholders.create.title') }}
        </span>
        <span v-else>
          {{ $t('signup.stakeholders.edit.title') }}
        </span>
      </v-card-title>
      <v-card-text>
        <v-form v-model="valid" ref="create-form" lazy-validation>
          <v-row no-gutters class="mt-4">
            <!------------------------------------------>
            <!-- EMAIL --------------------------------->
            <!------------------------------------------>
            <v-col cols="12">
              <v-text-field
                v-model="form.email"
                :label="$t('common.email')"
                :rules="rules.email"
                class="rounded-lg font-weight-regular"
                outlined
                dense
              />
            </v-col>
            <!------------------------------------------>
            <!-- STATUS -------------------------------->
            <!------------------------------------------>
            <v-col cols="12">
              <v-select
                v-model="form.status"
                :items="statuses"
                :label="$t('common.status')"
                :rules="rules.status"
                item-text="text"
                item-value="value"
                class="rounded-lg font-weight-regular"
                outlined
                dense
              />
            </v-col>
          </v-row>
        </v-form>
      </v-card-text>
      <v-card-actions class="justify-end mx-2">
        <v-btn color="#2661FF" outlined class="rounded-lg" @click="closeDialog">
          {{ $t('actions.cancel') }}
        </v-btn>
        <v-btn
          color="#2661FF"
          class="rounded-lg white--text"
          @click="saveStakeholder"
          :disabled="!valid"
          :loading="loading"
        >
          {{ $t('actions.save') }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapActions } from 'vuex'

export default {
  name: 'HandleStakeholderDialog',
  props: {
    value: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      loading: false,
      valid: false,
      form: {
        id: null,
        email: null,
        status: null
      },
      rules: {
        email: [
          v =>
            !!v ||
            this.$t('messages.validation_error.required', {
              field: this.$t('common.email')
            }),
          v =>
            /.+@.+\..+/.test(v) ||
            this.$t('messages.validation_error.email', {
              field: this.$t('common.email')
            }),
          v =>
            (v && v.length <= 125) ||
            this.$t('messages.validation_error.max', {
              field: this.$t('common.email'),
              length: 125
            })
        ],
        status: [
          v =>
            !!v ||
            this.$t('messages.validation_error.required', {
              field: this.$t('common.status')
            })
        ]
      },
      statuses: [
        {
          text: this.$t('common.active'),
          value: 1
        },
        {
          text: this.$t('common.inactive'),
          value: 2
        }
      ]
    }
  },
  created() {
    const { value } = this
    const { stakeholder } = value

    if (value.type === 'edit') {
      this.form = { ...stakeholder }
    }
  },
  computed: {
    localDisplay: {
      get() {
        return this.value.display
      },
      set(value) {
        this.$emit('update:display', value)
      }
    }
  },
  methods: {
    ...mapActions({
      editStakeholder: 'signup/editStakeholder',
      createStakeholder: 'signup/createStakeholder'
    }),
    async saveStakeholder() {
      const { value } = this

      const formRef = this.$refs['create-form']

      const validation = formRef.validate()

      if (!validation) return

      this.loading = true

      switch (value.type) {
        case 'create':
          await this.createStakeholder(this.form)
          break
        case 'edit':
          await this.editStakeholder(this.form)
          break
      }

      this.$emit('fetchStakeholders')
      this.closeDialog()
      this.loading = false
    },
    closeDialog() {
      this.$emit('close')
    }
  }
}
</script>

<style lang="scss">
.text-color {
  color: #344054 !important;
}
</style>
